export const TRANSACTION_STATUS = {
  success: "SUCCESS",
  pending: "PENDING",
  errored: "ERRORED",
};
